module.exports = __webpack_public_path__ + "static/media/img-horizontal-ealry-leave@3x.4ed7fcaf.png";